export class SurveyRequestValue {
  parameterId: string;
  textValue: string;
  numericValue: number;
  booleanValue: boolean;
  answerIds: string[];
}
